import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreatePageRequest, Page, UpdatePageRequest } from '@models/page.model';
import { environment } from '@environment/environment';

@Injectable({providedIn: 'root'})
export class PageService {
  private readonly http = inject(HttpClient);
  private readonly ENDPOINT = 'pages';

  getAll(webshopId?: string): Observable<Page[]> {
    const url = webshopId
      ? `${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}`
      : `${environment.apiBaseUrl}/${this.ENDPOINT}`;
    return this.http.get<Page[]>(url);
  }

  get(webshopId: string, pageId: string): Observable<Page> {
    return this.http.get<Page>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}/${pageId}`);
  }

  create(webshopId: string, page: CreatePageRequest): Observable<Page> {
    return this.http.post<Page>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}`, page);
  }

  update(webshopId: string, page: Partial<UpdatePageRequest> & { id: string }): Observable<Page> {
    return this.http.patch<Page>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}/${page.id}`, page);
  }

  delete(webshopId: string, pageId: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}/${pageId}`);
  }
}
